// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css - Header组件样式 */

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  height: 60px;
  background: rgba(5, 8, 16, 0.85);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(0, 229, 255, 0.15);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

/* ===== Logo区域 ===== */
.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--secondary), var(--primary));
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 0 15px rgba(0, 229, 255, 0.4),
    0 0 25px rgba(126, 87, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.logo-icon::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.15) 50%,
    transparent 70%
  );
  animation: logoShine 3s linear infinite;
}

@keyframes logoShine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.logo-icon i {
  color: #fff;
  font-size: 14px;
}

.logo-text {
  font-family: 'Orbitron';
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  position: relative;
  background: linear-gradient(
    to right,
    #ffffff 0%,
    #00e5ff 25%,
    #7e57ff 50%,
    #00e5ff 75%,
    #ffffff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-size: 200% auto;
  animation: textShine 4s linear infinite;
  text-shadow:
    0 0 10px rgba(0, 229, 255, 0.3),
    0 0 20px rgba(126, 87, 255, 0.2);
}

@keyframes textShine {
  0% { background-position: 200% center; }
  100% { background-position: -200% center; }
}

/* ===== Header Actions区域 ===== */
.header-actions {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 12px;
  align-items: center;
}

/* ===== 用户区域 ===== */
.user-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* 积分显示 */
.points-display {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  color: #ffd700;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.points-display:hover {
  opacity: 0.8;
}

.points-display i {
  font-size: 1.2rem;
}

.points-value {
  font-family: 'Orbitron', sans-serif;
}

/* 用户菜单容器 */
.user-menu-container {
  position: relative;
}

.user-profile-btn {
  position: relative;
}

.user-profile-btn .fa-chevron-down {
  font-size: 0.7rem;
  margin-left: 4px;
  transition: transform 0.3s;
}

.user-profile-btn .fa-chevron-down.rotate {
  transform: rotate(180deg);
}

/* 用户下拉菜单 */
.user-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: rgba(20, 20, 30, 0.98);
  border: 1px solid rgba(0, 240, 255, 0.3);
  border-radius: 8px;
  padding: 8px 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #ccc;
  font-size: 0.9rem;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
}

.menu-item:hover {
  background: rgba(0, 240, 255, 0.1);
  color: #00f0ff;
}

.menu-item i {
  width: 20px;
  text-align: center;
  font-size: 1rem;
}

.menu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 8px 0;
}

.menu-item.logout {
  color: #ff6b6b;
}

.menu-item.logout:hover {
  background: rgba(255, 107, 107, 0.1);
  color: #ff4444;
}

/* 登录按钮 & 用户资料按钮 */
.login-btn,
.user-profile-btn {
  background: rgba(0, 229, 255, 0.1);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(0, 229, 255, 0.3);
  color: var(--primary);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  font-family: 'Orbitron', sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow:
    0 0 20px rgba(0, 229, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.login-btn:hover,
.user-profile-btn:hover {
  background: rgba(0, 229, 255, 0.2);
  border-color: rgba(0, 229, 255, 0.5);
  box-shadow:
    0 0 30px rgba(0, 229, 255, 0.25),
    0 0 40px rgba(126, 87, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.login-btn:active,
.user-profile-btn:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
}

.login-btn i,
.user-profile-btn i {
  font-size: 0.9rem;
}

.login-btn:hover i,
.user-profile-btn:hover i {
  transform: scale(1.1);
}

/* 语言切换按钮 */
.language-switcher {
  background: rgba(0, 229, 255, 0.1);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(0, 229, 255, 0.25);
  color: var(--primary);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  font-family: 'Orbitron', sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow:
    0 0 20px rgba(0, 229, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  z-index: 100;
}

.language-switcher::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.6s ease;
}

.language-switcher:hover::before {
  left: 100%;
}

.language-switcher:hover {
  background: rgba(0, 229, 255, 0.2);
  border-color: rgba(0, 229, 255, 0.4);
  box-shadow:
    0 0 30px rgba(0, 229, 255, 0.25),
    0 0 40px rgba(126, 87, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.language-switcher:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
}

.language-switcher i {
  font-size: 0.9rem;
  transition: transform 0.3s ease;
}

.language-switcher:hover i {
  transform: rotate(15deg);
}

/* 响应式设计 */
@media (max-width: 768px) {
  header {
    padding: 0 3%;
  }

  .header-actions {
    right: 15px;
    gap: 8px;
  }

  .login-btn,
  .user-profile-btn {
    padding: 6px 12px;
    font-size: 0.75rem;
    gap: 6px;
  }

  .login-btn i,
  .user-profile-btn i {
    font-size: 0.8rem;
  }

  .language-switcher {
    padding: 6px 12px;
    font-size: 0.75rem;
    gap: 6px;
  }

  .language-switcher i {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .logo-text {
    font-size: 20px;
  }

  .login-btn span,
  .user-profile-btn span,
  .language-switcher span {
    display: none;
  }

  .login-btn,
  .user-profile-btn,
  .language-switcher {
    padding: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    justify-content: center;
  }

  .login-btn i,
  .user-profile-btn i,
  .language-switcher i {
    font-size: 1rem;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,gDAAgD;EAChD,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;oCAEkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,uCAAuC;AACzC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;;;;;GAOC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC;;oCAEkC;AACpC;;AAEA;EACE,KAAK,gCAAgC,EAAE;EACvC,OAAO,iCAAiC,EAAE;AAC5C;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;0CAEwC;AAC1C;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC;;;2CAGyC;EACzC,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;0CAEwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC;;;2CAGyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;;;IAGE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;;IAGE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["/* Header.css - Header组件样式 */\n\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 5%;\n  height: 60px;\n  background: rgba(5, 8, 16, 0.85);\n  backdrop-filter: blur(15px);\n  border-bottom: 1px solid rgba(0, 229, 255, 0.15);\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n}\n\n/* ===== Logo区域 ===== */\n.logo-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logo-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, var(--secondary), var(--primary));\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow:\n    0 0 15px rgba(0, 229, 255, 0.4),\n    0 0 25px rgba(126, 87, 255, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.logo-icon::before {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    45deg,\n    transparent 30%,\n    rgba(255, 255, 255, 0.15) 50%,\n    transparent 70%\n  );\n  animation: logoShine 3s linear infinite;\n}\n\n@keyframes logoShine {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n.logo-icon i {\n  color: #fff;\n  font-size: 14px;\n}\n\n.logo-text {\n  font-family: 'Orbitron';\n  font-size: 26px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 2px;\n  position: relative;\n  background: linear-gradient(\n    to right,\n    #ffffff 0%,\n    #00e5ff 25%,\n    #7e57ff 50%,\n    #00e5ff 75%,\n    #ffffff 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  background-size: 200% auto;\n  animation: textShine 4s linear infinite;\n  text-shadow:\n    0 0 10px rgba(0, 229, 255, 0.3),\n    0 0 20px rgba(126, 87, 255, 0.2);\n}\n\n@keyframes textShine {\n  0% { background-position: 200% center; }\n  100% { background-position: -200% center; }\n}\n\n/* ===== Header Actions区域 ===== */\n.header-actions {\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* ===== 用户区域 ===== */\n.user-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* 积分显示 */\n.points-display {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  color: #ffd700;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.points-display:hover {\n  opacity: 0.8;\n}\n\n.points-display i {\n  font-size: 1.2rem;\n}\n\n.points-value {\n  font-family: 'Orbitron', sans-serif;\n}\n\n/* 用户菜单容器 */\n.user-menu-container {\n  position: relative;\n}\n\n.user-profile-btn {\n  position: relative;\n}\n\n.user-profile-btn .fa-chevron-down {\n  font-size: 0.7rem;\n  margin-left: 4px;\n  transition: transform 0.3s;\n}\n\n.user-profile-btn .fa-chevron-down.rotate {\n  transform: rotate(180deg);\n}\n\n/* 用户下拉菜单 */\n.user-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 200px;\n  background: rgba(20, 20, 30, 0.98);\n  border: 1px solid rgba(0, 240, 255, 0.3);\n  border-radius: 8px;\n  padding: 8px 0;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  color: #ccc;\n  font-size: 0.9rem;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.menu-item:hover {\n  background: rgba(0, 240, 255, 0.1);\n  color: #00f0ff;\n}\n\n.menu-item i {\n  width: 20px;\n  text-align: center;\n  font-size: 1rem;\n}\n\n.menu-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 8px 0;\n}\n\n.menu-item.logout {\n  color: #ff6b6b;\n}\n\n.menu-item.logout:hover {\n  background: rgba(255, 107, 107, 0.1);\n  color: #ff4444;\n}\n\n/* 登录按钮 & 用户资料按钮 */\n.login-btn,\n.user-profile-btn {\n  background: rgba(0, 229, 255, 0.1);\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba(0, 229, 255, 0.3);\n  color: var(--primary);\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-family: 'Orbitron', sans-serif;\n  font-weight: 500;\n  letter-spacing: 1px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow:\n    0 0 20px rgba(0, 229, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.login-btn:hover,\n.user-profile-btn:hover {\n  background: rgba(0, 229, 255, 0.2);\n  border-color: rgba(0, 229, 255, 0.5);\n  box-shadow:\n    0 0 30px rgba(0, 229, 255, 0.25),\n    0 0 40px rgba(126, 87, 255, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n}\n\n.login-btn:active,\n.user-profile-btn:active {\n  transform: translateY(0);\n  transition: transform 0.1s ease;\n}\n\n.login-btn i,\n.user-profile-btn i {\n  font-size: 0.9rem;\n}\n\n.login-btn:hover i,\n.user-profile-btn:hover i {\n  transform: scale(1.1);\n}\n\n/* 语言切换按钮 */\n.language-switcher {\n  background: rgba(0, 229, 255, 0.1);\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba(0, 229, 255, 0.25);\n  color: var(--primary);\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-family: 'Orbitron', sans-serif;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow:\n    0 0 20px rgba(0, 229, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  position: relative;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.language-switcher::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.1),\n    transparent\n  );\n  transition: left 0.6s ease;\n}\n\n.language-switcher:hover::before {\n  left: 100%;\n}\n\n.language-switcher:hover {\n  background: rgba(0, 229, 255, 0.2);\n  border-color: rgba(0, 229, 255, 0.4);\n  box-shadow:\n    0 0 30px rgba(0, 229, 255, 0.25),\n    0 0 40px rgba(126, 87, 255, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n}\n\n.language-switcher:active {\n  transform: translateY(0);\n  transition: transform 0.1s ease;\n}\n\n.language-switcher i {\n  font-size: 0.9rem;\n  transition: transform 0.3s ease;\n}\n\n.language-switcher:hover i {\n  transform: rotate(15deg);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  header {\n    padding: 0 3%;\n  }\n\n  .header-actions {\n    right: 15px;\n    gap: 8px;\n  }\n\n  .login-btn,\n  .user-profile-btn {\n    padding: 6px 12px;\n    font-size: 0.75rem;\n    gap: 6px;\n  }\n\n  .login-btn i,\n  .user-profile-btn i {\n    font-size: 0.8rem;\n  }\n\n  .language-switcher {\n    padding: 6px 12px;\n    font-size: 0.75rem;\n    gap: 6px;\n  }\n\n  .language-switcher i {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo-text {\n    font-size: 20px;\n  }\n\n  .login-btn span,\n  .user-profile-btn span,\n  .language-switcher span {\n    display: none;\n  }\n\n  .login-btn,\n  .user-profile-btn,\n  .language-switcher {\n    padding: 8px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    justify-content: center;\n  }\n\n  .login-btn i,\n  .user-profile-btn i,\n  .language-switcher i {\n    font-size: 1rem;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
